import React from 'react'
import { Empty, Input, Icon, notification } from 'antd'
import { injectIntl } from 'react-intl'
import { isEmpty } from 'lodash'
import request from 'utils/request'
import styles from './style.module.scss'

@injectIntl
class LiveSearch extends React.Component {
  state = {
    showSearch: false,
    searchText: '',
    includeOrders: 1,
    includeMembers: 1,
    customers: [],
    orders: [],
  }

  componentWillMount() {
    document.addEventListener('keydown', this.handleKeyDown, false)
  }

  showLiveSearch = () => {
    setTimeout(() => {
      this.searchInput.focus()
    }, 100)
    this.setState({
      showSearch: true,
    })
  }

  changeSearchText = async e => {
    const searchText = e.target.value
    const { includeOrders, includeMembers } = this.state
    this.setState({
      searchText,
    })

    if (searchText && searchText.length >= 3) {
      if (!includeOrders && !includeMembers) {
        notification.warning({
          message: 'Warning',
          description: 'Select one of the checkboxes',
        })
        return
      }
      const res = await request('admin/search', {
        params: {
          term: searchText,
          customers: includeMembers,
          orders: includeOrders,
        },
      })
      this.setState({
        customers: res.data.result.customers,
        orders: res.data.result.orders,
      })
    }
  }

  hideLiveSearch = () => {
    this.searchInput.blur()
    this.setState({
      showSearch: false,
      searchText: '',
    })
  }

  handleKeyDown = event => {
    const { showSearch } = this.state
    if (showSearch) {
      const key = event.keyCode.toString()
      if (key === '27') {
        this.hideLiveSearch()
      }
    }
  }

  handleNode = node => {
    this.searchInput = node
  }

  render() {
    const { showSearch, searchText, customers, orders } = this.state
    const {
      intl: { formatMessage },
    } = this.props

    return (
      <div className="d-inline-block mr-4">
        <Input
          className={styles.extInput}
          placeholder={formatMessage({ id: 'topBar.typeToSearch' })}
          prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)' }} />}
          style={{ width: 200 }}
          onFocus={this.showLiveSearch}
        />
        <div
          className={`${
            showSearch ? `${styles.livesearch} ${styles.livesearchVisible}` : styles.livesearch
          }`}
          id="livesearch"
        >
          <button className={styles.close} type="button" onClick={this.hideLiveSearch}>
            <span className="utils__visibilityHidden">Закрыть</span>
            <i className="icon-cross2" />
          </button>

          <div className="container-fluid">
            <div className={styles.wrapper}>
              <div className={styles.logoContainer}>
                <img className={styles.logo} src="resources/images/logo.svg" alt="" />
              </div>
              <input
                type="search"
                className={styles.searchInput}
                value={searchText}
                onChange={this.changeSearchText}
                id="livesearchInput"
                placeholder="Type to search..."
                ref={this.handleNode}
                autoComplete="off"
              />
              <ul className={styles.options}>
                {/* <li className={`${styles.option} ${styles.optionCheckbox}`}>
                  <Checkbox
                    value={includeMembers}
                    checked={includeMembers}
                    onChange={e => this.setState({ includeMembers: e.target.checked ? 1 : 0 })}
                  >
                    Search within members
                  </Checkbox>
                </li>
                <li className={`${styles.option} ${styles.optionCheckbox}`}>
                  <Checkbox
                    value={includeOrders}
                    checked={includeOrders}
                    onChange={e => this.setState({ includeOrders: e.target.checked ? 1 : 0 })}
                  >
                    Search within orders
                  </Checkbox>
                </li> */}
                <li className={styles.option}>Type to start searching</li>
              </ul>
              {(!isEmpty(customers) || !isEmpty(orders)) && (
                <div className={styles.results}>
                  <div className={styles.resultsTitle}>
                    <span>Search Results</span>
                  </div>
                  <div className="row">
                    <div className="col-lg-4">
                      {customers.map(customer => (
                        <div key={customer.id} className={styles.resultContent}>
                          <a
                            href={`/dataentry/${customer.id}`}
                            className={styles.matchUser}
                            onClick={this.hideLiveSearch}
                          >
                            <div
                              className={styles.resultThumb}
                              style={{
                                backgroundImage: `url(${
                                  customer.photo_url
                                    ? customer.photo_url
                                    : 'resources/images/avatars/temp.jpg'
                                })`,
                              }}
                            />
                            <div className={styles.result}>
                              <div className={styles.resultText}>
                                {customer.first_name} {customer.last_name}
                              </div>
                              <div className={styles.resultSource}>{customer.suite_string_id}</div>
                            </div>
                          </a>
                        </div>
                      ))}
                      {/* <div className={styles.resultContent}>
                        <a href="/dataentry" onClick={this.hideLiveSearch}>
                          <div
                            className={styles.resultThumb}
                            style={{ backgroundImage: 'url(resources/images/avatars/2.jpg)' }}
                          />
                          <div className={styles.result}>
                            <div className={styles.resultText}>Julia Roberts</div>
                            <div className={styles.resultSource}>383-393</div>
                          </div>
                        </a>
                      </div>
                      <div className={styles.resultContent}>
                        <a href="/dataentry" onClick={this.hideLiveSearch}>
                          <div
                            className={styles.resultThumb}
                            style={{ backgroundImage: 'url(resources/images/avatars/3.jpg)' }}
                          />

                          <div className={styles.result}>
                            <div className={styles.resultText}>Jackson Anderson</div>
                            <div className={styles.resultSource}>909-393</div>
                          </div>
                        </a>
                      </div> */}
                    </div>
                  </div>
                </div>
              )}
              {isEmpty(customers) && isEmpty(orders) && (
                <Empty
                  description={
                    <span>
                      {searchText ? (
                        <span>
                          No result for <strong>{searchText}</strong>
                        </span>
                      ) : (
                        <span>Please search...</span>
                      )}
                    </span>
                  }
                />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default LiveSearch
